import React from 'react';
import TopBar from '../../../Components/TopBar';
import StretchBtn from '../../../Components/TopBar/StretchBtn';

const Builder = () => {
    return <>
        <TopBar title="Builder" right={<StretchBtn pref="websiteBuilder:widthExpanded" />} />
        <p>Hello</p>
    </>
}

export default Builder;